//Site styles: Vite extracts this to deploy/public/css/debug.css at build
//(nothing lands in the JS output) — the css.blade.php <link> path is unchanged.
import '../sass/debug.scss';

import { Core } from 'core/Core';

//Load all the controllers
import { AppController } from 'app/controller/AppController';
import { PixiController } from 'app/services/PixiController';
import { PreloadController } from 'app/chrome/preload/PreloadController';
import { UIController } from 'app/views/ui/UIController';
import { NavMenuController } from 'app/chrome/navmenu/NavMenuController';
import { ProjectsMenuController } from 'app/views/projectsmenu/ProjectsMenuController';
import { VerticalDragController } from 'app/chrome/verticaldrag/VerticalDragController';
import { MouseController } from 'app/chrome/mouse/MouseController';
import { HomeController } from 'app/views/home/HomeController';
import { WorkController } from 'app/views/work/WorkController';
import { ProjectController } from 'app/views/project/ProjectController';
import { AboutController } from 'app/views/about/AboutController';
import { ScrollbarController } from 'app/chrome/scrollbar/ScrollbarController';
import { HistoryController } from 'app/services/HistoryController';
import 'module.imports';

//Controller needs to
//1.) Load all app controllers
//2.) Decide what needs to run as core
//3.) Decide what needs to run as

console.warn = function () {};

//Viewport size caching lives in utils/device (snapshot taken at its module
//init, refreshed first thing in App._onResize) — no boot write needed here.

Core.controller.add(
	//Global and UI:
	{ instance: new PreloadController('Preload'), global: true, selector: '.preload' },
	{ instance: new UIController('UI'), global: true, selector: '.ui' },
	{ instance: new NavMenuController('NavMenu'), global: true, selector: '.navmenu' },
	{ instance: new ProjectsMenuController('ProjectsMenuController'), global: true, selector: '.projects__menu' },

	{ instance: new HistoryController('History'), global: true },
	{ instance: new MouseController('Mouse'), global: true, selector: 'body' },
	{ instance: new VerticalDragController('VerticalDrag'), global: true },
	{ instance: new ScrollbarController('Scrollbar'), global: true, selector: '.scrollbar' },
	//Main views:
	{ instance: new HomeController('Home'), selector: '.home' },
	{ instance: new WorkController('Screens'), selector: '.work.-screens' },
	{ instance: new WorkController('Spaces'), selector: '.work.-spaces' },
	{ instance: new WorkController('Systems'), selector: '.work.-systems' },
	{ instance: new ProjectController('Project'), selector: '.project' },
	{ instance: new AboutController('About'), selector: '.about' },
	{ instance: new PixiController('Pixi'), global: true },
	{ instance: new AppController('App'), global: true }
);

Core.route.set([
	{ path: 'screens', controller: 'Screens', function: 'screens' },
	{ path: 'spaces', controller: 'Spaces', function: 'spaces' },
	{ path: 'systems', controller: 'Systems', function: 'systems' },
	{ path: 'project', controller: 'Project', function: 'init' },
	{ path: 'project/:projectslug', controller: 'Project', function: 'init' },
	{ path: 'info', controller: 'About', function: 'info' },
	{ path: 'studio', controller: 'About', function: 'studio' },
	{ path: 'what-we-do', controller: 'About', function: 'whatWeDo' },
	{ path: 'our-process', controller: 'About', function: 'ourProcess' },
	{ path: 'jobs', controller: 'About', function: 'jobs' },
	{ path: 'contact', controller: 'About', function: 'contact' },
	{ path: '/', controller: 'Home' },
	//Dev harness (local-only server route, see config/dev.ts) — same Home init:
	{ path: 'dev/home', controller: 'Home' },
	{ path: 'dev/home/:department', controller: 'Home' }
]);

Core.init();
